import { render, staticRenderFns } from "./Galerija.vue?vue&type=template&id=a02ca60e&scoped=true&"
import script from "./Galerija.vue?vue&type=script&lang=js&"
export * from "./Galerija.vue?vue&type=script&lang=js&"
import style0 from "./Galerija.vue?vue&type=style&index=0&id=a02ca60e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a02ca60e",
  null
  
)

export default component.exports